import { render, staticRenderFns } from "./projectInfoWidget.vue?vue&type=template&id=eee756b6&scoped=true"
import script from "./projectInfoWidget.vue?vue&type=script&lang=js"
export * from "./projectInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./projectInfoWidget.vue?vue&type=style&index=0&id=eee756b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee756b6",
  null
  
)

export default component.exports